module.exports = __webpack_public_path__ + "img/16m009-08.6905e520.png";